import { useState, useEffect } from 'react';
import { create } from 'zustand';
import { useQueryResourceDetail } from '../../queries/useQueryResourceDetail.js';
import { delayedTrackZustand } from '@fabric-app/compat/capabilities/openreplay';

const useResourcesMoveStore = create()(delayedTrackZustand((set) => ({
  resources: null,
  setResourcesToMove: (resources) => set({
    resources
  }),
  close: () => set({
    resources: null
  })
})));
const resourceMoveModal = {
  open: (variables) => {
    useResourcesMoveStore.getState().setResourcesToMove(variables.resources);
  },
  close: () => {
    useResourcesMoveStore.getState().setResourcesToMove(null);
  }
};
const useOpenMoveModalWithResourceId = () => {
  const [resourceId, setResourceId] = useState(null);
  const { data } = useQueryResourceDetail(resourceId);
  useEffect(() => {
    if (data && data.id === resourceId) {
      resourceMoveModal.open({
        resources: [
          data
        ]
      });
      setResourceId(null);
    }
  }, [
    data,
    resourceId
  ]);
  return setResourceId;
};

export { resourceMoveModal, useOpenMoveModalWithResourceId, useResourcesMoveStore };
//# sourceMappingURL=moveResourcesStore.js.map
